export const blockIconsMapsNavigationNew = (
	<span className='material-symbols-outlined'>navigation</span>
);
